module.exports = __webpack_public_path__ + "img/stars-img.7bd5f399.png";